import axios from 'axios';
import PathManagement from '../common/path-management';
import { getResponseByUrl, postResponseByUrl } from '../common/xhr';

export default class NewsletterSub {

    newsletter!: Newsletter;

    async subToNewsletter(devData, check, email = ''): Promise<Newsletter> {
        let _pathManager = new PathManagement();
        let url = _pathManager.getNewsletterUrl();
        let data = {
            deviceData: devData,
            newsletter: check, 
            email: email
        }
        try { 
            this.newsletter = await postResponseByUrl(url, data);
        } catch (err) {
            console.error(err, 'error al intentar suscribirse al newsletter');
        }

        return this.newsletter;
    }

    }


export interface Newsletter {
    newsletter: any
}